import { dataAPI } from "./api"

let isInitialized = false
let isHealthy = false

export const checkHealth = (): Promise<string> => dataAPI.getText("_health")

export const isDataApiHealthy = (): Promise<boolean> => {
    if (isInitialized) {
        return Promise.resolve(isHealthy)
    }

    return checkHealth()
        .then(() => {
            isHealthy = true
            isInitialized = true
            return isHealthy
        })
        .catch(() => {
            isHealthy = false
            isInitialized = true
            return isHealthy
        })
}
